import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

function ProtectedRoute({ children, allowedRoles }) {
  
  // Obtiene la ubicación actual
  const location = useLocation();
  
  // Obtiene la información del usuario del almacenamiento local
  const userJson = localStorage.getItem('usuario');

  // Parsea la información del usuario si existe, si no, establece user como null
  const user = userJson ? JSON.parse(userJson) : null;
  
  // Comprueba si el usuario existe y si su rol está permitido
  if (!user || !allowedRoles.includes(user.rol)) {
    
    // Si el usuario no está autenticado o no tiene el rol permitido,
    // redirige a la página principal, guardando la ubicación actual
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Si el usuario está autenticado y tiene el rol permitido, renderiza los componentes hijos
  return children;
}

export default ProtectedRoute;